export default function QuoteTime() {

    return (
        <span className="sidebar-component">
            <div className="sidebar-component-text-container">
                <h3 className="info-left">2 mins</h3>
                <p className="info-right">it's quick to compare quotes from our panel of trusted providers.</p>
            </div>
        </span>
    )
}